import { Component, ViewEncapsulation, inject, signal } from "@angular/core";
import { ConfirmationService, MessageService, PrimeTemplate } from "primeng/api";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { Bookings } from "src/app/models/bookings";
import {
  PAIED_TYPE_LIST,
  PARAM_BILLINGS_PATH,
} from "../../constants/constants";
import { Billings } from "src/app/models/billings";
import { BillingsService } from "src/app/services/billings.service";
import { Bind } from "primeng/bind";
import { Drawer } from "primeng/drawer";
import { SlicePipe, CurrencyPipe, DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { InputText } from "primeng/inputtext";
import { Select } from "primeng/select";
import { DatePicker } from "primeng/datepicker";
import { ButtonDirective } from "primeng/button";
import { TopNavComponent } from "../../top-nav/top-nav.component";
import { TableModule } from "primeng/table";
import { Tag } from "primeng/tag";
import { NgxPaginationModule } from "ngx-pagination";
import { Card } from "primeng/card";
import { InitialsAvatarComponent } from "../../components/initials-avatar/initials-avatar.component";
import { ConfirmDialog } from "primeng/confirmdialog";
import { Toast } from "primeng/toast";
import { KeysPipe } from "../../pipe/key.pipe";

import { DynamicFiltersComponent } from "../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-manage-billings",
    templateUrl: "./manage-billings.component.html",
    styleUrl: "./manage-billings.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, Select, DatePicker, ButtonDirective, TopNavComponent, RouterLink, TableModule, Tag, NgxPaginationModule, Card, InitialsAvatarComponent, ConfirmDialog, Toast, SlicePipe, CurrencyPipe, DatePipe, KeysPipe]
})
export class ManageBillingsComponent extends AbstractListController<
  Billings,
  any
> {
  protected billingsService: BillingsService;
  private messageService = inject(MessageService);
  protected confirmationService: ConfirmationService;

  title = "Fatture";
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);
  readonly roomDialog = signal<boolean>(false);
  booking: Bookings;
  readonly billing = signal<Billings>(undefined);
  readonly selectedSkills = signal<any[]>(undefined);

  constructor() {
    const billingsService = inject(BillingsService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      billingsService,
      confirmationService,
      router,
      route,
      PARAM_BILLINGS_PATH,
    );
    this.billingsService = billingsService;
    this.confirmationService = confirmationService;

    this.cols.set([
      { field: "is_paid", header: "Pagata" },
      { field: "surname", header: "Cognome" },
      { field: "date_from", header: "Dal" },
      { field: "date_to", header: "Al" },
      { field: "phone", header: "Cellulare" },
      { field: "city", header: "Indirizzo" },
    ]);

    this.colsFilter.set([
      {
        field: "is_paid",
        icon: "pi-wallet",
        header: "Stato",
        type: "select",
        option: PAIED_TYPE_LIST,
      },
      { field: "number", icon: "pi-hashtag", header: "Numero", type: "string" },
      { field: "date_gte", icon: "pi-calendar", header: "Emessa dal", type: "date" },
      { field: "date_lte", icon: "pi-calendar", header: "Emessa fino al", type: "date" },
    ]);
  }

  initials(billing: any): string {
    const c = billing?.client;
    return (
      `${c?.name ?? ""} ${c?.surname ?? ""}`
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((w: string) => w[0])
        .join("")
        .toUpperCase() || "?"
    );
  }

  open(billing: Billings) {
    this.edit(billing);
  }

  closeBilling(billing: Billings) {
    const formData = new FormData();

    formData.set("is_paid", "0");
    this.billingsService.update(formData, billing.id).subscribe(
      (res) => {
        this.load();
        this.messageService.add({
          key: "myKey1",
          severity: "success",
          summary: "Attenzione",
          detail: "Aggiornato con success",
        });
      },
      (error) => (this.error.set(error)),
    );
  }

  openBilling(billing: Billings) {
    const formData = new FormData();

    formData.set("is_paid", "1");

    this.billingsService.update(formData, billing.id).subscribe(
      (res) => {
        this.load();
        this.messageService.add({
          key: "myKey1",
          severity: "success",
          summary: "Attenzione",
          detail: "Aggiornato con success",
        });
      },
      (error) => (this.error.set(error)),
    );
  }

  edit(billing: Billings) {
    this.billing.set({ ...billing });
    this.selectedSkills.set(JSON.parse("" + this.billing().skills + ""));
    this.roomDialog.set(true);
  }
}
